import React from 'react'
import { Route, BrowserRouter as Router, Routes, Link  } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import config from '../Config';

export const Banner = () => {
  return (
    <>
    <section className='banner-bg bg-transparentcustm'>
      <img src={`${config.siteBaseUrl}/assets/imgs/our-integrations-bg.svg`} alt='' className='bghgt'/>
      
        <Container>
           <Row>
            <Col xs lg="12" className='text-left'>
            <span><img src='assets/imgs/h-icon.svg' alt='' />HIGH RISK BUSINESSES</span>
            <h1>Tailored solutions for every challenge</h1>
            </Col>
            <Col xs lg="7" className='text-left'>
            <p>TCB Pay specializes in providing tailored merchant accounts for high-risk clients in various industries. We understand that being labeled as high-risk can be a burden, and we offer customized solutions to fit your business needs.</p>
            <Link className="get-btn2 mt-10" to="https://calendly.com/chris-tcb/high-risk" target='blank'>Get Started</Link>
            <Link className="contact-btn1 mt-10" to={`${config.siteBaseUrl}/contact`}>Contact Us</Link>
            </Col>
          </Row>  
        </Container>
    </section>
    </>
  )
}
